import React from 'react';
import { Typography, Stack } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import { ValidationResult } from '../../../../features/signUp/hooks/usePasswordChecklist';

interface PasswordChecklistProps {
  validationResults: ValidationResult[];
}

interface IconProps {
  isValid: boolean;
  shouldShowError: boolean;
}

const Icon = ({ isValid, shouldShowError }: IconProps) => {
  if (isValid) {
    return <CheckCircleIcon fontSize="small" color="success" />;
  }
  if (shouldShowError) {
    return <CancelIcon fontSize="small" color="error" />;
  }
  return <PanoramaFishEyeIcon fontSize="small" sx={{ color: 'grey.700' }} />;
};

const getTextColor = (isValid: boolean, shouldShowError: boolean) => {
  if (isValid) {
    return 'success.main';
  }
  if (shouldShowError) {
    return 'error.main';
  }
  return 'text.secondary';
};

export const PasswordChecklist = ({ validationResults }: PasswordChecklistProps) => (
  <Stack spacing={1} id="password-checklist">
    {validationResults.map((result) => (
      <Stack
        key={result.rule}
        direction="row"
        spacing={1}
        alignItems="center"
        id={`password-rule-${result.rule}`}
      >
        <Icon isValid={result.isValid} shouldShowError={result.shouldShowError} />
        <Typography
          variant="body2"
          color={getTextColor(result.isValid, result.shouldShowError)}
          id={`password-rule-text-${result.rule}`}
        >
          {result.label}
        </Typography>
      </Stack>
    ))}
  </Stack>
);

export default PasswordChecklist;
